// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".filter--container[data-v-eab458be] {\n  width: 100%;\n}\n.filter-select[data-v-eab458be] {\n  max-width: 300px;\n}\n.container[data-v-eab458be] {\n  margin-left: 250px;\n  margin-right: 250px;\n  max-width: calc(100vw - 300px);\n}\n.form-title[data-v-eab458be] {\n  display: flex;\n}\ntr[data-v-eab458be] {\n  background-color: #ffffff;\n}\ntr[data-v-eab458be]:nth-child(odd) {\n  background-color: #f6f6f6;\n}", ""]);
// Exports
module.exports = exports;
